import * as React from "react";
import type { SVGProps } from "react";
const SvgPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 5a1 1 0 1 0-2 0zm-2 14a1 1 0 1 0 2 0zm-6-8a1 1 0 1 0 0 2zm14 2a1 1 0 1 0 0-2zm-8-8v14h2V5zm-6 8h14v-2H5z"
    />
  </svg>
);
export default SvgPlus;
